import { environment } from "../../config";
import {
  DeletedTipos,
  iDataTipo,
  TipoFields,
} from "../../interfaces/SuperAdmin/Pages/iDataTipos";
import { fetchData } from "./httpClient";

const { REACT_APP_API_OAS } = environment;
const baseApiBroker = REACT_APP_API_OAS;


export const getTiposByOrgId = (id_organizacion: string) =>
  fetchData<iDataTipo[]>({
    method: "GET",
    url: `${baseApiBroker}/tipo/organizacion/${id_organizacion}`,
  });

export const deleteTipos = (data: { ids: string[] }) =>
  fetchData<DeletedTipos>({
    method: "DELETE",
    url: `${baseApiBroker}/tipo`,
    data,
  });

export const putTipoById = (data: TipoFields, id_tipo: string) =>
  fetchData<iDataTipo>({
    method: "PUT",
    url: `${baseApiBroker}/tipo/${id_tipo}`,
    data,
  });

export const postTipo = (data: TipoFields, id_organizacion: string) =>
  fetchData<iDataTipo>({
    method: "POST",
    url: `${baseApiBroker}/tipo/organizacion/${id_organizacion}`,
    data,
  });
